<script setup lang="ts">
import {RcsCarousel, RcsSuggestion} from "@/notification-template/interfaces";
import {Carousel, CarouselContent, CarouselItem} from "@/core/components/ui/carousel";
import RCSCard from "@/notification-template/components/rcs/RCSCard.vue";
import RCSSuggestion from "@/notification-template/components/rcs/RCSSuggestion.vue";

defineProps<{
    payload: RcsCarousel;
}>();

defineEmits<{
    (e: 'suggestionClick', suggestion: RcsSuggestion): void
}>();
</script>

<template>
  <div>
    <Carousel>
      <CarouselContent>
        <CarouselItem v-for="(card, index) in payload.cards" :key="index" class="pb-2 basis-[85%]">
          <RCSCard :payload="card" @suggestion-click="$emit('suggestionClick', $event)" />
        </CarouselItem>
      </CarouselContent>
    </Carousel>
    <div v-if="payload.suggestions?.length" class="flex px-2 flex-wrap gap-1">
      <RCSSuggestion
        v-for="(suggestion, index) in payload.suggestions ?? []"
        :key="index"
        :payload="suggestion"
        @click="$emit('suggestionClick', suggestion)"
      />
    </div>
  </div>
</template>
